import { z } from 'my-zod'
import { customerWaiversModel } from './customer-waivers-model'

export const customerWaiverSnapshotUrlsSearchResult = customerWaiversModel
  .pick({
    id: true,
    waiverOrigination: true,
    createdDate: true
  })
  .augment({
    waiverFormSnapshotUrl: z.string()
  })

export type customerWaiverSnapshotUrlsSearchResult = z.infer<typeof customerWaiverSnapshotUrlsSearchResult>
